module.exports = __webpack_public_path__ + "img/shares.e670dcd7.svg";